//Actions
const UPDATE_IBT_DATE = "ibt/UPDATE_IBT_DATE";
const SET_SELECTED_IBT_DATA = "ibt/SET_SELECTED_IBT_DATA";
const SET_IBT_HEADER_LOADING = "ibt/SET_IBT_HEADER_LOADING";
const SET_IBT_SIDEBAR_LOADING = "ibt/SET_IBT_SIDEBAR_LOADING";
const SET_IBT_RESULT_LIST_LOADING = "ibt/SET_IBT_RESULT_LIST_LOADING";
const SET_SHOW_SIDEBAR_LIST = "ibt/SET_SHOW_SIDEBAR_LIST";

// 액션 생성 함수
export const updateIbtDate = (ibtDate: any) => ({ type: UPDATE_IBT_DATE, ibtDate });
export const setSelectedIbtData = (selectedIbtData: any) => ({ type: SET_SELECTED_IBT_DATA, selectedIbtData });
export const setIbtHeaderLoading = (ibtHeaderLoading: boolean) => ({ type: SET_IBT_HEADER_LOADING, ibtHeaderLoading });
export const setIbtSidebarLoading = (ibtSidebarLoading: boolean) => ({ type: SET_IBT_SIDEBAR_LOADING, ibtSidebarLoading });
export const setIbtResultListLoading = (ibtResultListLoading: boolean) => ({ type: SET_IBT_RESULT_LIST_LOADING, ibtResultListLoading });
export const setShowSidebarList = (showSidebarList: boolean) => ({ type: SET_SHOW_SIDEBAR_LIST, showSidebarList });

// 초깃값 (상태가 객체가 아니라 그냥 숫자여도 상관 없습니다.)
const initialState = {
	ibtDate: {
			startDate: null,
			endDate: null
	},
	selectedIbtData: null,
	ibtHeaderLoading: false,
	ibtSidebarLoading: false,
	ibtResultListLoading: false,
	showSidebarList: false
};

export default function organization(state = initialState, action) {
  switch (action.type) {
		case UPDATE_IBT_DATE:
			/*
			return {
				...state,
				ibtDate: action.ibtDate
			}
			*/
			return {
				...state,
				ibtDate: {
					...state.ibtDate,
					...action.ibtDate
				}
			}
		case SET_SELECTED_IBT_DATA:
			return {
				...state,
				selectedIbtData: action.selectedIbtData
			}
		case SET_IBT_HEADER_LOADING:
			return {
				...state,
				ibtHeaderLoading: action.ibtHeaderLoading
			}
		case SET_IBT_SIDEBAR_LOADING:
			return {
				...state,
				ibtSidebarLoading: action.ibtSidebarLoading
			}
		case SET_IBT_RESULT_LIST_LOADING:
			return {
				...state,
				ibtResultListLoading: action.ibtResultListLoading
			}
		case SET_SHOW_SIDEBAR_LIST:
			return {
				...state,
				showSidebarList: action.showSidebarList
			}
    default:
      return state;
  }
} 